export const SHOW_ALERT_DISPLAY_TIME = 10000; // 10000ms
